import { NumberUtils } from './../../utils/number-utils';

/**
 * A dataservice that performs external top up operations
 */
export class ExternalTopUpsService {
  public externalTopUpResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.ExternalTopUpResponse>;

  constructor($resource) {
    this.externalTopUpResource = $resource(
      'api/external-top-ups/:id',
      undefined,
      {
        save: {
          method: 'POST',
          headers: {
            'Access-Control-Expose-Headers': 'Location'
          },
          transformResponse: (data, headers) => {
            const response: any = {};
            response.data = data;
            (<any>response).headers = headers();
            return response;
          }
        }
      });
  }

  /**
   * Creates a new external top up
   *
   * @param externalTopUp An object representation of an external topup to be created
   *
   * @returns A promise that resolves once the POST operation is complete
   */
  public createExternalTopUp(externalTopUp) {
    return this.externalTopUpResource.save(externalTopUp).$promise;
  }


  /**
   * Get an external top up by id
   *
   * @param id the id of the external top up to retrieve
   *
   * @returns A promise that resolves with the external top ui
   */
  public getExternalTopUp(id: string) {
    return this.externalTopUpResource.get({ id: id }).$promise;
  }

  /**
   * A method that returns a new ExternalTopUp object using the supplied arguments
   * @param shopTopUpData the topup data recorded by the shop / external party
   * @param chargeAccount the charge account that the topup relates to
   **/
  public getNewExternalTopUp(shopTopUpData: InterACT.Interfaces.ITopupData,
    chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount): InterACT.Interfaces.ChargeAccounts.ExternalTopUp {
    return {
      scheme: chargeAccount.scheme,
      chargeAccount: {
        link: `/charge-accounts/${chargeAccount.id}`
      },
      status: 'PENDING',
      shopName: shopTopUpData.shopName,
      amount: NumberUtils.round(shopTopUpData.amount)
    }
  }
}